/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userSchema } from "./userSchema.ts";
import { z } from "zod";

export const accountMemberSchema = z.lazy(() => userSchema).and(z.object({
      "id": z.string(),
  "isAdmin": z.boolean().describe("Indique si le membre est administrateur de l'organisation").optional()
      }))